import React, { Component } from 'react';
import PopUp from '../../../commonModules/interface/PopUp';
import Currency from '../../../commonModules/Currency';
import { Box, Button, Table, TableBody, TableRow, TableCell, TableHead, Typography, Card, CardHeader } from '@material-ui/core';
import { TableLayout } from '../Stock/containers/Layout';
import { FaceRounded, ListRounded, PersonRounded, PrintRounded } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import FacturePreview from '../../AdminDashboard/Society/FacturePreview';
// import logo_mjb from '../../../../../../img/logo_mjb.png'

const translate = {
    "Homme": "M.",
    "Femme": "Mme",
}
class ClientState extends Component {
    state = { 
        name: "",
        phone: "",
        address: "",
        city: "",
        country: "",
        gender: "",
     }
    componentDidMount = () => {
        this.getUserInfo()
    }
    getUserInfo = async () => {
        let methodName = 'Get user Info : '+ this.props.boxAssoId;
        var url = "/user/info/paygo?boxAssoId=" + this.props.boxAssoId;
        try{
            const res = await fetch(url, {
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            })
            const data = await res.json()
            //CHECK ERR
            this.setState({
                name: `${translate[data.info.Type] || ""} ${data.info.Nom || ""} ${data.info.Prénom || ""}`,
                phone: data.info["Téléphone 1"] || "",
                address: data.info.Adresse || "",
                city: data.info.city || "",
                country: data.info.country || "",
                gender: data.info.Type,
            });
        } catch (error) {
            console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
            console.log(error); // on transfère l'objet de l'exception à une méthode
            return;
        }
    }
    // getUserInfo = async () => {
    //     const { boxAssoId } = this.props;
    //     let methodName = 'Get user Info : '+ boxAssoId;
    //     var url = "user/infopaygo?boxAssoId=" + boxAssoId;
    //     try{
    //         const res = await fetch(url, {
    //             method:'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
    //             },
    //             credentials: 'same-origin',
    //         })
    //         const data = await res.json()
    //         //CHECK ERR
    //         this.setState({
    //             name: data.name || "",
    //             phone: data.phone || "",
    //             email: data.email || "",
    //             address: data.address || "",
    //             city: data.city || "",
    //             country: data.country || "",
    //             gender: data.gender || "",
    //             phone2: data.phone2 || "",
    //             carteId: data.carteId || ""
    //         });
    //     } catch (e) {
    //         // les instructions utilisées pour gérer les
    //         // exceptions
    //         console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
    //         console.log(e); // on transfère l'objet de l'exception à une méthode
    //         return;
    //     }
    // }
    render() {
        const { userInfo, abo, paymentsIDList, PAYMENTS } = this.props;

        let abo_start = 0
        if(paymentsIDList.length > 0){ // totalPAYED <--> totalToPAY inversed
            abo_start = new Date(paymentsIDList[0])
        }

        
        return (
            <PopUp 
                title="Etat Abonnement" 
                close={this.props.close}
                scroll="paper"
            >
                {/* <Box p={2} className="text-right m-10">
                    <Button 
                        color="secondary"
                        className="btn btn-warning" 
                        onClick={() => window.print()}
                    >
                        Imprimer
                    </Button>
                </Box> */}
                <Box p={2} style={{textAlign: "right"}}>
                    <Button 
                        color="secondary" 
                        onClick={() => window.print()}
                        startIcon={<PrintRounded />}
                    >
                        Imprimer
                    </Button>
                </Box>
                
                <FacturePreview>

                    <Box m={1} style={{ float: "right", width: "250px"}}>
                        <Typography variant="body1"><b>{this.state.name}</b></Typography>
                        <Typography variant="body1">Box n° {userInfo.idBox}</Typography>
                        <address>
                            {/* Adresse: {this.state.address} <br/>
                            Tel: {this.state.phone} <br/> */}
                            <Typography variant="body2">{this.state.phone}</Typography>
                            <Typography variant="body2">{this.state.address}</Typography>
                            {/* <Typography variant="body2">{this.state.city} - {this.state.country}</Typography> */}
                        </address>

                    </Box>
                    <div style={{clear: "both"}}></div>
                    {/* <hr/> */}
                    <br />
                    <Alert severity="info">
                        <br />
                        <Typography variant="body2">Vous avez souscrit à un abonnement <b>{abo.name}</b> d'un montant total de <b><Currency value={abo.total} /></b> </Typography>
                        <Typography variant="body2">En date du <b>{new Date().toLocaleDateString("fr-FR") }</b> vous avez payé <b><Currency value={userInfo.totalPayed} /></b></Typography>
                        <Typography variant="body2">Il vous reste <b><Currency value={(abo.total - userInfo.totalPayed)} /></b> à rembourser</Typography>
                        <br />
                    </Alert>
                    <Box p={2}></Box>
                    <Box className="title-print">
                        <CardHeader
                            disableTypography	
                            title={<Typography variant="h6">Résumé</Typography>}
                            avatar={<PersonRounded />}
                        />
                    </Box>
                    <Box p={2}>
                        <TableLayout>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Client depuis le</TableCell>
                                    <TableCell>{new Date(abo_start).toLocaleDateString('fr-FR')}</TableCell>
                                </TableRow>
                                {/* <TableRow>
                                    <TableCell>Fin d'abonnement prévue</TableCell>
                                    <TableCell>{new Date(abo_endTS).toLocaleDateString('fr-FR')} ({Math.round(length_abo_days - days_since_start)} Jours)</TableCell>
                                </TableRow> */}
                                <TableRow>
                                    <TableCell>Type Abonnement</TableCell>
                                    <TableCell>
                                        {abo.name} - <b><Currency value={abo.total} /></b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Total Payé</TableCell>
                                    <TableCell>
                                        <Currency value={userInfo.totalPayed} />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Reste à Payer</TableCell>
                                    <TableCell>
                                        <Currency value={(abo.total - userInfo.totalPayed)} />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Récurrence Paiement</TableCell>
                                    <TableCell> 
                                        <Currency value={abo.type === 'Cash' ? this.props.abo.total : this.props.abo.mensualite} /> {this.props.abo.type === 'Cash' ? " Paiement Unique" : ` Tous les ${userInfo.periodicity} jours`}
                                        {/* <Currency value={Math.round(abo.mensualite / userInfo.periodicity * 31) } />  */}
                                    </TableCell>
                                </TableRow>

                            </TableBody>
                        </TableLayout>
                    </Box>
                    <Box id="pagebreak">
                        <Box className="title-print">
                            {/* <Typography variant="h5">Liste des paiements</Typography> */}
                            <CardHeader
                                disableTypography	
                                title={<Typography variant="h6">Liste des paiements</Typography>}
                                avatar={<ListRounded />}
                            />
                        </Box>
                        <Box p={2}>
                            <TableLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Montant</TableCell>
                                        <TableCell>Mode Réglement</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {[...paymentsIDList].reverse().map( ID => {
                                    let payment = PAYMENTS[ID]
                                    if (payment && payment.methodPayment !== "gift" && payment.Status !== "cancel") {
                                        return (
                                        <TableRow>
                                            <TableCell>{new Date(payment.timePayment).toLocaleDateString("fr-FR")}</TableCell>
                                            <TableCell><Currency value={payment.money} suffix=" " /> </TableCell>
                                            <TableCell>{payment.methodPayment}</TableCell>
                                        </TableRow>
                                        )
                                    }
                                })
                                }
                                </TableBody>
                            </TableLayout>
                        </Box>
                    </Box>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <Box p={2}  
                        style={{
                            // textAlign: "right", 
                            width:"100px", 
                            position:"static", 
                            bottom: "20px",
                            width: "100%",
                        }}
                    >
                        Signature: 
                    </Box>
                </FacturePreview>
            </PopUp>
        );
    }
}

export default ClientState;